<button class="firebase-sign-in" @click="signInWithGoogle" title="Sign in with Google"></button>